import {TabBody} from "../../../tab-content";
import {ManagedTab} from "../../../managed-tabs";

import "./ClientHierarchyOverviewTab.scss";

import {ClientHierarchyDetailsColumn} from "./ClientHierarchyDetailsColumn";
import {ClientHierarchyBoidsColumn} from "./ClientHierarchyBoidsColumn";
import {ClientHierarchyActionButtons} from "../ClientHierarchyActionButtons";

export const ClientHierarchyOverviewTab: ManagedTab = () => {
  return (
    <TabBody name={"overview"}>
      <ClientHierarchyActionButtons />
      <ClientHierarchyDetailsColumn />
      <ClientHierarchyBoidsColumn />
    </TabBody>
  );
};
